import { useState, useEffect } from 'react';
import { useGetOrder } from '@hungryroot/orders';
import { type OrderV1IncludesAll as OrderIncludesAll } from '@hungryroot/rest';
import { convertBundledOrderToOrder } from '../../../../components/order/orderTransforms';

interface Props {
  order: OrderIncludesAll;
  children: (order: OrderIncludesAll) => void;
}

const OrderWrapper = (props: Props) => {
  const { order, children } = props;
  const [newOrder, setNewOrder] = useState<OrderIncludesAll | null>(null);
  const { data } = useGetOrder(order.id);

  useEffect(() => {
    if (order.has_bundles && data) {
      setNewOrder(convertBundledOrderToOrder(data, order));
    } else {
      setNewOrder(order);
    }
  }, [order.has_bundles, data]);

  return newOrder !== null && children(newOrder);
};

export default OrderWrapper;
